<template lang="">
  <div class="container" @click="close()">
    <div class="mains">
      <transition name="transition-drop">
        <div class="main" v-show="show1" @click.stop>
          <div class="top">
            <div class="select">
              <Input
                v-model="selectVal"
                @on-search="selectbtn()"
                search
                placeholder="输入标题"
              />
            </div>
          </div>
          <el-empty description="没有数据哦！" v-if="pageData.length == 0" />
          <Table
            border
            :columns="columns"
            :data="pageData"
            style="width: 100%; height: 100%"
            v-if="pageData.length !== 0"
          >
            <template #name="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
            <template #action="{ row, index }">
              <Button style="margin-right: 5px" @click="select(index)"
                >选择</Button
              >
            </template>
          </Table>
          <!-- 分页 -->
          <Page
            class="page"
            :modelValue="pages"
            :total="allPage"
            simple
            @on-change="page"
          />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { GetProductList, DelProductList } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "ID",
          key: "id",
          width: 100,
        },
        {
          title: "企业代码",
          key: "clientCode",
          width: 120,
        },
        {
          title: "产品编号",
          key: "title",
          width: 200,
        },
        {
          title: "产品名称",
          key: "ProductName",
          width: 200,
        },
        {
          title: "添加时间",
          key: "time",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 100,
          align: "center",
          fixed: "right",
        },
      ],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
      index: "",
      show1: false,
    };
  },
  mounted() {},
  watch: {},
  created() {
    clearTimeout(t1);
    var t1 = setTimeout(() => {
      this.show1 = true;
    }, 100);

    let control = this.$store.state.control;
    if (control !== "1") {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }
    this.getProducts();
  },
  methods: {
    selectbtn() {
      this.getProducts();
    },
    // 获取产品信息
    getProducts() {
      GetProductList({
        code: 1,
        page: this.pages,
        pagesize: 10,
        name: this.selectVal,
      }).then((res) => {
        this.pageData = res.list;
        this.allPage = res.size;
      });
    },
    close() {
      this.$emit("closeDealer", false);
    },
    select(index) {
      this.$emit("Value", this.pageData[index]);
      this.close();
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getProducts();
    },
  },
};
</script>
<style scoped>
.mains {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999999;
}
.top {
  width: 100%;
  background: white;
  padding: 15px;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  width: 950px;
  height: auto;
  border-radius: 10px;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
